import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/co2_footprint/comparison');
  return response.data;
}

export default {
  index,
};
